// Thrown by threeSixtyApiCall on an error status, so callers can tell e.g. a 404 from a network failure
export class ThreeSixtyApiError extends Error {
	status: number;

	constructor(status: number, message: string) {
		super(message);
		this.name = 'ThreeSixtyApiError';
		this.status = status;
	}
}
